import { triggerConfirmationDialog } from '../dialogs/ConfirmationDialog';

export const confirmResetProcessDefinitionSpList = (
    confirm: (reset?: boolean) => void,
    dismiss: () => void,
    listName?: string
): void => {
    listName = listName?.trim();

    if (listName) {
        listName = ` "${listName}" `;

        triggerConfirmationDialog({
            confirmFn: () => confirm(true),
            dismissFn: () => {
                dismiss();
            },
            confirmText: 'Zurücksetzen',
            content: [
                'Die Einstellungen dieser Prozessdefinition, wie Berechtigungen,',
                `SharePoint Aktionen und Emails sind auf die Liste${listName}bezogen.`,
                'Durch das ändern der Liste bzw. das Erstellen einer Vorlage oder das Exportieren',
                'passen die Einstellungen wahrscheinlich nicht mehr und müssen überarbeitet werden.\n\n',
                `Möchten Sie, dass die Einstellungen korrigiert und auf die Liste${listName}bezogene Vorgaben zurückgesetzt werden?`,
                '\n\nHINWEIS: Nicht listenbezogene Vorgaben bleiben unberührt!',
            ].join(' '),
            secondaryConfirm: {
                confirmFn: () => confirm(),
                confirmText: 'Ohne Zurücksetzen',
            },
            title: 'Einstellungen der Prozessdefinition zurücksetzen',
        });
    } else {
        confirm();
    }
};

export const confirmResetProcessDefinition = (confirm: (reset?: boolean) => void): void => {
    triggerConfirmationDialog({
        confirmFn: () => confirm(true),
        confirmText: 'Zurücksetzen',
        content: [
            'Möchten Sie, dass die Einstellungen der Prozessdefinition, wie z.B. SharePoint Liste',
            ', Berechtigungen, SharePoint Aktionen und Emails, zurückgesetzt werden?',
            '\n\nHINWEIS: Prozessbezogene Einstellungen, wie z.B. Prozess-ID werden immer zurückgesetzt.',
        ].join(''),
        secondaryConfirm: {
            confirmFn: () => confirm(),
            confirmText: 'Ohne Zurücksetzen',
        },
        title: 'Einstellungen der Prozessdefinition zurücksetzen',
    });
};
